// extracted by mini-css-extract-plugin
export default {"framework-selector":"R_ck d-flex","framework-selector__icon":"R_cl","framework-selector__option":"R_cm p-2 flex-grow-1 ml-2","framework-selector__option--selected":"R_cn"};